<template>
  <div>
    <SampleSearchForm
      :listForm="searchList"
      @handlerSearch="onSearch"
      @handlerBtn="handlerBtn"
    />
    <div class="cml-button-group">
      <el-button
        size="mini"
        type="primary"
        :disabled="selectTab.length < 1"
        v-hasPermission="'outside-warehouse-manage/outside-goods-btn'"
        @click="confirmBtn"
        :loading="confirmLoading"
        >确认收货</el-button
      >
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      @page-size-change="pageSizeChange"
      @select-change="selectChange"
    >
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{
          row.code
        }}</span>
      </template>
      <!-- 明细状态 -->
      <template #detailSlot="{ row }">
        <div>
          <el-button
            v-if="row.detailId"
            type="text"
            @click="ckeckDetail(row)"
            >查看明细</el-button
          >
        </div>
      </template>
    </CommonTable>
    <!-- 批量操作后的弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="resultDialogVisible"
    >
      <ResultDialog
        :dialogResult="dialogResult"
        :tableDataField="'failResultList'"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="resultDialogVisible = false"
          size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog center top="5vh" :visible.sync="dialogVisible" width="1200px">
      <OutsideSample v-if="dialogVisible && status === 'detail'" :id="id" :detailId="detailId" />
      <div v-if="status === 'detail'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import ResultDialog from '@/components/ResultDialog';
import OutsideSample from '@/components/OutsideSample';
export default {
  components: { CommonTable, SampleSearchForm, ResultDialog, OutsideSample },
  props: {},
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
      },
      tableHeadTab: [
        { label: '产品名称', prop: 'productName' },
        {
          label: '寻样单编号',
          prop: 'code',
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'unit', width: 80 },
        { label: '样品类型', prop: 'productTypeName' },
        { label: '供应商', prop: 'supplierName' },
        { label: '采购备注', prop: 'forSupplierRemark' },
        { label: '要求到样时间', prop: 'askArrivalTime', width: 140 },
        { label: '供应商备注', prop: 'supplierRemark' },
        { label: '寄出时间', prop: 'deliveryDate' },
        { label: '快递公司', prop: 'express' },
        { label: '快递单号', prop: 'expressNo' },
        // {
        //   label: '明细状态',
        //   prop: 'operate',
        //   slotColumn: true,
        //   slotName: 'detailSlot',
        //   width: 150,
        // },
      ],
      tableDataTab: {},
      listForm: { detailStatus: 'DELIVERY' },
      selectTab: [],
      dialogResult: {},
      resultDialogVisible: false,
      confirmLoading: false,
      dialogVisible: false,
      status: '',
      id: '',
      detailId: ''
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight(10);
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.outsideSampleManage
        .getOrderDeliveryInfo(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectTab = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // table选择框
    selectChange(arr) {
      this.selectTab = arr;
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // 确认收货
    handlerBtn(val, data) {
      this[val](val, data);
    },
    confirmBtn() {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.confirmLoading = true;
          this.$http.outsideSampleManage
            .batchReceipt(this.selectTab.map(item => item.detailId))
            .then(() => {
              // if (result.data.failNum === 0) {
              //   this.$message.success('确认收货成功');
              //   this.$emit('on-success');
              // } else {
              //   this.dialogResult = result.data;
              //   this.resultDialogVisible = true;
              // }
              this.$message.success('确认收货成功');
            })
            .catch(err => {
              this.$message.error(err.msg);
            })
            .finally(() => {
              this.getList();
              this.confirmLoading = false;
            });
        })
        .catch(() => {
          return false;
        });
    },
    toUpdate(row, status) {
      this.status = status;
      this.id = row.id;
      this.detailId = '';
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    },
    ckeckDetail(row) {
      this.status = 'detail';
      this.id = row.id;
      this.detailId = row.detailId;
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    }
  },
};
</script>

<style lang="less" scoped>

</style>
